import { render, staticRenderFns } from "./ManageAccount.vue?vue&type=template&id=71b0fb2c&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"
import style0 from "./ManageAccount.vue?vue&type=style&index=0&id=71b0fb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0fb2c",
  null
  
)

export default component.exports